/* Produktkarten: „+N" für weitere Farben – 7 O'CLOCK
   Angelegt: 2026-09-30

   Gilt in der Kollektionsübersicht und in Slidern mit der neuen Karte.
   Passen mobil nicht alle Farben in die Zeile, steht hinter der letzten ganz
   sichtbaren Farbe ein „+3" (Anzahl der weiteren Farben); die übrigen sind
   ausgeblendet. Tippen auf „+3" oder Wischen nach links zeigt die weiteren
   Farben; nach rechts über den Anfang hinaus geht es nicht (kein Gummiband),
   und die Zählung wird beim Scrollen nie neu berechnet.

   Ergänzung 01.10.2026: Kartentitel zweizeilig – „…, Green Silence" wird am letzten
   Komma geteilt, Kollektionsname („Green Silence") in Zeile 1, Produktname kleiner in
   Zeile 2. Linktext bleibt komplett (SEO). Ohne Komma bleibt der Titel wie er ist.

   Styles: assets/custom-product-card.css
   Eingebunden über snippets/gtm-head.liquid. */
(function () {
  'use strict';

  var RESERVE = 30; // Platz für „+N" inkl. Abstand (px)

  var observer = typeof ResizeObserver !== 'undefined' ? new ResizeObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.target.__ocUpdate) entry.target.__ocUpdate();
    });
  }) : null;

  function setup(wrap) {
    if (wrap.__ocUpdate) return;
    var card = wrap.closest('.product-card-new');
    // Im Kollektionsgrid ist die Karte display:contents -> Anker ist das Grid-Item,
    // in Slidern (z. B. „Weitere passende Produkte") die Karte selbst.
    var anchor = wrap.closest('.filter_product-list-item') || card;
    if (!anchor || !card) return;
    if (getComputedStyle(anchor).position === 'static') anchor.style.position = 'relative';

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'oc-swatch-more';
    btn.tabIndex = -1;
    anchor.appendChild(btn);

    var state = { n: 0, show: false };

    /* Einmal am Reihenanfang berechnen: wie viele Farben passen vor das „+N"?
       Wird NICHT beim Scrollen neu berechnet – das „+N" bleibt damit fest. */
    function compute() {
      wrap.scrollLeft = 0;
      var swatches = wrap.querySelectorAll('.product-card-new_swatch');
      var overflow = wrap.scrollWidth > wrap.clientWidth + 2;
      var show = overflow && swatches.length > 1 && window.innerWidth < 992;
      var n = swatches.length;
      var gap = 14;

      if (show) {
        var cs = getComputedStyle(wrap);
        var right = wrap.getBoundingClientRect().right - (parseFloat(cs.paddingRight) || 0);
        gap = parseFloat(getComputedStyle(swatches[0].parentElement).columnGap) || gap;
        n = 0;
        for (var i = 0; i < swatches.length; i++) {
          if (swatches[i].getBoundingClientRect().right + gap + RESERVE <= right) n = i + 1;
          else break;
        }
        if (n < 1) n = 1;
        if (n >= swatches.length) show = false;
      }

      // Die aktive Farbe muss am Anfang sichtbar sein: ggf. nach vorn holen
      if (show) {
        for (var m = n; m < swatches.length; m++) {
          if (swatches[m].classList.contains('is-active')) {
            swatches[m].parentElement.insertBefore(swatches[m], swatches[n - 1]);
            swatches = wrap.querySelectorAll('.product-card-new_swatch');
            break;
          }
        }
      }

      state.n = n;
      state.show = show;

      if (show) {
        var hidden = swatches.length - n;
        var last = swatches[n - 1].getBoundingClientRect();
        var a = anchor.getBoundingClientRect();
        btn.textContent = '+' + hidden;
        btn.setAttribute('aria-label', hidden + ' weitere Farben anzeigen');
        btn.style.left = Math.round(last.left + last.width + gap - a.left) + 'px';
        btn.style.top = Math.round(last.top - a.top) + 'px';
      }
      apply();
    }

    /* Beim Scrollen nur ein-/ausblenden: am Anfang „+N" + versteckte Farben,
       weiter rechts alle Farben ohne „+N". Zählung bleibt unverändert. */
    function apply() {
      var atStart = wrap.scrollLeft <= 4; // auch bei Gummiband (negativ) = Anfang
      var showNow = state.show && atStart;
      var swatches = wrap.querySelectorAll('.product-card-new_swatch');
      for (var k = 0; k < swatches.length; k++) {
        swatches[k].classList.toggle('oc-swatch-hidden', showNow && k >= state.n);
      }
      btn.classList.toggle('is-visible', showNow);
    }

    wrap.__ocUpdate = compute;
    wrap.addEventListener('scroll', apply, { passive: true });
    // Farbwechsel (Alpine tauscht is-active) -> neu rechnen, falls am Anfang
    wrap.addEventListener('click', function () {
      setTimeout(function () { if (wrap.scrollLeft <= 4) compute(); else apply(); }, 50);
    });
    // „+N": weitere Farben zeigen (Reihe nach rechts schieben)
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      var target = wrap.scrollWidth - wrap.clientWidth;
      try { wrap.scrollTo({ left: target, behavior: 'smooth' }); } catch (err) { wrap.scrollLeft = target; }
      // Fallback für Browser ohne Smooth-Scroll bzw. wenn nichts passiert ist
      setTimeout(function () { if (wrap.scrollLeft < 4) wrap.scrollLeft = target; apply(); }, 350);
    });
    btn.addEventListener('touchend', function (e) { e.stopPropagation(); }, { passive: true });
    if (observer) observer.observe(wrap);
    compute();
  }

  function splitTitle(link) {
    if (link.querySelector('.oc-card-title_coll')) return;
    var text = (link.textContent || '').trim();
    var i = text.lastIndexOf(',');
    if (i < 1 || i === text.length - 1) return;
    var coll = text.slice(i + 1).trim();
    var name = text.slice(0, i).trim();
    if (!coll || !name) return;
    var a = document.createElement('span'); a.className = 'oc-card-title_coll'; a.textContent = coll;
    var b = document.createElement('span'); b.className = 'oc-card-title_name'; b.textContent = name;
    link.textContent = '';
    link.appendChild(a);
    link.appendChild(document.createTextNode(' '));
    link.appendChild(b);
  }

  function scan() {
    var list = document.querySelectorAll('.product-card-new_swatches-wrap');
    for (var i = 0; i < list.length; i++) setup(list[i]);
    var links = document.querySelectorAll('.product-card-new_heading .product-card-new_heading-link');
    for (var k = 0; k < links.length; k++) splitTitle(links[k]);
  }

  scan();

  // Neue Karten (Filter, „Mehr laden") mitnehmen
  if (window.MutationObserver) {
    var queued = false;
    new MutationObserver(function () {
      if (queued) return;
      queued = true;
      requestAnimationFrame(function () {
        queued = false;
        scan();
      });
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  window.addEventListener('load', function () { scan(); });
})();
